// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBoJSM8c5-ieAPHOAEpg6LHbZC2Cngo8GA",
  authDomain: "spurpunk-website.firebaseapp.com",
  projectId: "spurpunk-website",
  storageBucket: "spurpunk-website.firebasestorage.app",
  messagingSenderId: "650910175759",
  appId: "1:650910175759:web:acc08b288307f1f518097a",
  measurementId: "G-QZHVXP8LNY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
export { db };